(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["services-bookwell-main"] = factory();
	else
		root["services-bookwell-main"] = factory();
})(window, function() {
return 